export var UserRole;
(function (UserRole) {
    UserRole["Patient"] = "patient";
    UserRole["Provider"] = "provider";
})(UserRole || (UserRole = {}));
const { Patient: patient, Provider: provider } = UserRole;
export const translationsConfig = {
    en: {
        fileName: 'en',
        [provider]: true,
        [patient]: true,
        name: 'English',
    },
    es: {
        fileName: 'es',
        [provider]: true,
        [patient]: true,
        name: 'Spanish (Español)',
    },
    de: {
        fileName: 'de',
        [provider]: true,
        [patient]: true,
        name: 'German (Deutsch)',
    },
    // eslint-disable-next-line camelcase, @typescript-eslint/naming-convention
    en_test: {
        fileName: 'en-test',
        [provider]: true,
        [patient]: true,
        name: 'Test locale',
        test: true,
    },
    ar: {
        fileName: 'ar',
        [provider]: true,
        [patient]: true,
        name: 'Arabic (العربية)',
    },
    fi: {
        fileName: 'fi',
        [provider]: true,
        [patient]: true,
        name: 'Finnish (Suomi)',
    },
    fr: {
        fileName: 'fr',
        [provider]: true,
        [patient]: true,
        name: 'French (Français)',
    },
    el: {
        fileName: 'el',
        [provider]: true,
        [patient]: true,
        name: 'Greek (Ελληνικά)',
    },
    hi: {
        fileName: 'hi',
        [provider]: true,
        [patient]: true,
        name: 'Hindi (हिन्दी)',
    },
    hr: {
        fileName: 'hr',
        [provider]: true,
        [patient]: true,
        name: 'Croatian (Hrvatski)',
    },
    it: {
        fileName: 'it',
        [provider]: true,
        [patient]: true,
        name: 'Italian (Italiano)',
    },
    ja: {
        fileName: 'ja',
        [provider]: true,
        [patient]: true,
        name: 'Japanese (日本語)',
    },
    ko: {
        fileName: 'ko',
        [provider]: true,
        [patient]: true,
        name: 'Korean (한국어)',
    },
    nl: {
        fileName: 'nl',
        [provider]: true,
        [patient]: true,
        name: 'Dutch (Nederlands)',
    },
    pl: {
        fileName: 'pl',
        [provider]: true,
        [patient]: true,
        name: 'Polish (Polski)',
    },
    pt: {
        fileName: 'pt',
        [provider]: true,
        [patient]: true,
        name: 'Portuguese (Português)',
    },
    ro: {
        fileName: 'ro',
        [provider]: true,
        [patient]: true,
        name: 'Romanian (Română)',
    },
    ru: {
        fileName: 'ru',
        [provider]: true,
        [patient]: true,
        name: 'Russian (Русский)',
    },
    sv: {
        fileName: 'sv',
        [provider]: true,
        [patient]: true,
        name: 'Swedish (Svenska)',
    },
    uk: {
        fileName: 'uk',
        [provider]: true,
        [patient]: true,
        name: 'Ukrainian (Українська)',
    },
    ur: {
        fileName: 'ur',
        [provider]: true,
        [patient]: true,
        name: 'Urdu (اردو)',
    },
    vi: {
        fileName: 'vi',
        [provider]: true,
        [patient]: true,
        name: 'Vietnamese (Tiếng Việt)',
    },
    'zh-CN': {
        fileName: 'zh-CN',
        [provider]: true,
        [patient]: true,
        name: 'Chinese Simplified (简体中文)',
    },
    'zh-TW': {
        fileName: 'zh-TW',
        [provider]: true,
        [patient]: true,
        name: 'Chinese Traditional (繁體中文)',
    },
};
//# sourceMappingURL=constants.js.map